import React from 'react';
import { ArrowDownToLine, ArrowUpFromLine, BadgeEuro, Clock3, Landmark, ListFilter, ReceiptText, Send } from 'lucide-react';

const eur = (value) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(value || 0));

const cards = [
  { key: 'income', title: 'Entrate periodo', icon: ArrowDownToLine, tone: 'emerald', format: eur },
  { key: 'expenses', title: 'Uscite periodo', icon: ArrowUpFromLine, tone: 'rose', format: eur },
  { key: 'net_cash_flow', title: 'Flusso netto', icon: BadgeEuro, tone: 'blue', format: eur },
  { key: 'balance', title: 'Saldo disponibile', icon: Landmark, tone: 'slate', format: eur },
  { key: 'unclassified_count', title: 'Da riclassificare', icon: ListFilter, tone: 'amber', format: (v) => Number(v || 0) },
  { key: 'pending_count', title: 'PayPal sospesi', icon: Clock3, tone: 'amber', format: (v) => Number(v || 0) },
  { key: 'missing_documents_count', title: 'Documenti mancanti', icon: ReceiptText, tone: 'rose', format: (v) => Number(v || 0) },
  { key: 'to_invoice_total', title: 'Da fatturare', icon: Send, tone: 'indigo', format: eur },
];

const tones = {
  emerald: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  rose: 'border-rose-200 bg-rose-50 text-rose-800',
  blue: 'border-blue-200 bg-blue-50 text-blue-800',
  slate: 'border-slate-300 bg-slate-100 text-slate-800',
  amber: 'border-amber-300 bg-amber-50 text-amber-900',
  indigo: 'border-indigo-200 bg-indigo-50 text-indigo-800',
};

export const AccountingKpiGrid = ({ metrics = {} }) => (
  <section className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-3" data-testid="accounting-kpi-grid">
    {cards.map(({ key, title, icon: Icon, tone, format }) => (
      <article key={key} className={`min-w-0 border p-3 rounded-md ${tones[tone]}`} data-testid={`kpi-${key.replaceAll('_', '-')}-card`}>
        <div className="flex items-center justify-between gap-2">
          <span className="text-[11px] font-semibold uppercase text-slate-600">{title}</span>
          <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
        </div>
        <div className="mt-3 font-mono text-lg xl:text-xl font-bold tabular-nums break-words" data-testid={`kpi-${key.replaceAll('_', '-')}-value`}>
          {format(metrics[key])}
        </div>
      </article>
    ))}
  </section>
);